'use strict';
const angular = require('angular');

/*@ngInject*/
export function RecipientListService($resource) {
  return $resource('/api/recipient-lists/:id', {
    name: '@_id'
  },{
    getSystemList: {
      method: 'GET',
      url: '/api/recipient-lists/system/:role/:newsletter',
      isArray: true
    },
    getSystemListByAssociation: {
      method: 'GET',
      url: '/api/recipient-lists/association/:association/:newsletter',
      isArray: true
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduuApp.RecipientListService', [])
  .factory('RecipientListService', RecipientListService)
  .name;



// WEBPACK FOOTER //
// ./client/components/recipient-list/recipient-list.service.js